var $mediaPlayer = $('#media-player');
var playlistPlayer;

var playlistCssSelector = { jPlayer: "#jquery_jplayer_1", cssSelectorAncestor: "#jp_container_1" };

var myPlaylist = [];
 
var playlistOptions = { 
	playlistOptions: {
        autoPlay: true,
        enableRemoveControls: true
    },
    swfPath: "assets/js/libs/jplayer/jplayer/jquery.jplayer.swf",
    supplied: "mp3",
    useStateClassSkin: true,
    autoBlur: false,
    smoothPlayBar: true,
    keyEnabled: true,
};


(function( $ ) {

    var loggedid = '';
    var islogged = 0;
 
    islogged = document.getElementById("paramIsUserLogged").value;

    //loggedid = document.getElementById('paramIdUserLogged');
    if (document.getElementById('paramIdUserLogged') != null) {
        loggedid = document.getElementById("paramIdUserLogged").value;
    }else {
        loggedid = 0;
    }

	$('.jp-playlist-toggle').on('click', function(){
		$('.wr-jp-volume-controls').slideUp();
		$('.jp-playlist').slideToggle();
	});

	$('.jp-volume-toggle').on('click', function(){ 
		$('.jp-playlist').slideUp();
		$('.wr-jp-volume-controls').slideToggle();
    });

    $(document).ready(function($) {

        if(! $.isEmptyObject(myPlaylist)){
            $mediaPlayer.find('.radio-item .radio-item-img img').attr('src', myPlaylist[0].poster);
            $mediaPlayer.find('.radio-item .radio-item-img img').attr('alt', myPlaylist[0].title);
            $mediaPlayer.find('.radio-item .title').text(myPlaylist[0].title);
            $mediaPlayer.find('.radio-item .artist').text(myPlaylist[0].artist);
        }

        playlistPlayer = new jPlayerPlaylist(playlistCssSelector, myPlaylist, playlistOptions);

        $(playlistCssSelector.jPlayer).bind($.jPlayer.event.play, function(event) {
            var currentID = playlistPlayer.playlist[playlistPlayer.current].id;
            $('.radio-item-list .radio-item').each(function(){
                if($(this).hasClass('active')){
                    $(this).removeClass('active');
                }
                if($(this).find('.radio-item-img a').data('song-id') === currentID){
                    $(this).addClass('active');
                }
            });
	    	$('#media-player .radio-item .radio-item-img img').attr('src', playlistPlayer.playlist[playlistPlayer.current].poster);
	    	$('#media-player .radio-item .radio-item-img img').attr('alt', playlistPlayer.playlist[playlistPlayer.current].title);
	    	$('#media-player .radio-item .title').text(playlistPlayer.playlist[playlistPlayer.current].title);
	    	$('#media-player .radio-item .artist').text(playlistPlayer.playlist[playlistPlayer.current].artist);
        });

        // $(playlistCssSelector.jPlayer).on(event.jPlayer.status.paused, function(event) {
        //     console.log('playing');
        //     $('#media-player .radio-item .radio-item-img img').attr('src', 'assets/images/default.jpg');
        //     $('#media-player .radio-item .radio-item-img img').attr('alt', 'FM Derana Music');
        //     $('#media-player .radio-item .title').text('No media to play');
        //     $('#media-player .radio-item .artist').text('Select a song to play');
        // });
        
    }); 

    // jplayer playlist documentation
    // http://jplayer.org/latest/demo-02-jPlayerPlaylist/

    var is_song_exists = function(id){
        var exists = false;
        var list = playlistPlayer.playlist;

        $.each(list, function(index, song){
        if(song.id == id){
            exists = true;
            return false;
        }
        });
        return exists;
    };
    
    $(document).on("click", ".playlist-add", function () {

        var songID = $(this).data('song-id');

        if(is_song_exists(songID) == false){
            playlistPlayer.add({
                id: $(this).data('song-id'),
                title: $(this).data('song'),
                poster: $(this).data('poster'),
                artist: $(this).data('artist'),
                free: true,
                mp3: $(this).data('link'),
                file: $(this).data('file')
            });
            playlistPlayer.play(-1);
        } else{ 
            $.each(playlistPlayer.playlist, function(i, item) {
                if(item.id === songID){
                    playlistPlayer.play(i);
                }
            });​
        }
        
    });


    // add song to playlist
    $(document).on('click', '.add-to-playlist', function(){

        if(is_song_exists($(this).data('song-id')) == false){
            var song = {
                id: $(this).data('song-id'),
                title: $(this).data('song'),
                poster: $(this).data('poster'),
                artist: $(this).data('artist'),
                free: true,
                mp3: $(this).data('link'),
                file: $(this).data('file')
            };
            playlistPlayer.add(song);
            $('.jp-playlist').slideDown(); 
        }

    });


    $(document).on("click", ".add-to-favorite", function () {
        if (loggedid == 0) {
            alert('Please login to add favorite.');
        } else {
            var songId = $(this).attr("data-song-id");
            $.ajax({
                type: 'GET',
                //url: 'index2.php?route=fan/fan/favoriteAjax&songId=' + songId + '&user_id=' + loggedid,
                url: 'includes/add-fevorite.php',
                data: {songid: songId, uid: loggedid},
                dataType: 'text',
                success: function (responce) {
                    alert(responce);
                    //$('#addtofav').modal();
                }
            });
        } 
    });


    //featured queue all list
    $(document).on("click", ".featured-playlist-add", function () {
        // // var playlistPlayer;
        
        var upid = $(this).attr("up_id1");
        var poster_ = $(this).attr("poster");
        //alert(poster_);
        var this_ = $(this);
        // loader('start', this_);
        $.ajax({
            type: 'GET',
            //url: 'index2.php?route=fan/loadfeature&playlist_id=' + upid,
            url:'includes/get-featured-play-list.php',
            data: {playlist_id: upid},
            dataType: 'text',
            beforeSend: function() { 
                playlistPlayer.remove();  
            },
            success: function (responce) {
                var data = JSON.parse(responce);
                for (var i =0; i < data.length; i++) {
                    if (data[i] != "") {
                        if(is_song_exists(data[i]['id']) == false){
                            playlistPlayer.playlist.push({
                                id: data[i]['id'],
                                title: data[i]['name'],
                                artist: data[i]['artist'],
                                free: true,
                                poster: poster_,
                                mp3:'http://www.fmderana.lk/content/video/fmsongs/' + data[i]['file']
                            });
                        }
                    }
                }
                playlistPlayer.setPlaylist(playlistPlayer.playlist);
                $('.jp-playlist').slideDown(); 
                //loader('stop', this_);
            }
        });
        
    });


    //Play artist all songs
    $(document).on("click", ".play-all-songs", function () {
        // // var playlistPlayer;
        var poster_ = $(this).attr("poster");
        
        var upid = $(this).attr("artist-id");
        $.ajax({
            type: 'GET',
            //url: 'index2.php?route=fan/loadfeature&playlist_id=' + upid,
            url:'includes/play-all-songs.php',
            data: {playlist_id: upid},
            dataType: 'text',
            beforeSend: function() { 
                playlistPlayer.remove();  
            },
            success: function (responce) {

                var data = JSON.parse(responce);
                for (var i =0; i < data.length; i++) {
                    if (data[i] != "") {
                        if(is_song_exists(data[i]['id']) == false){
                            playlistPlayer.playlist.push({
                                id: data[i]['id'],
                                title: data[i]['name'],
                                artist: data[i]['artist'],
                                free: true,
                                //poster: data[i]['poster'],
                                poster: poster_,
                                mp3:'http://www.fmderana.lk/content/video/fmsongs/' + data[i]['file']
                            });
                        }
                    }
                }
                playlistPlayer.setPlaylist(playlistPlayer.playlist);
                $('.jp-playlist').slideDown(); 
                //loader('stop', this_);
            }
        });
        
    });



    $(document).on("click", ".queue-list-btns .btn-add", function (e) {
        e.preventDefault();
        var checkedSongs = 0;
        $(this).closest('.queue-list-header').next('.queue-list').find('.radio-item-list .radio-item').each(function(i, e){
            if($(this).find('input[type="checkbox"]').is(':checked')){
                if(is_song_exists($(this).find('.radio-item-img .playlist-add').data('song-id')) == false){
                    playlistPlayer.playlist.push({
                        id: $(this).find('.radio-item-img .playlist-add').data('song-id'),
                        title: $(this).find('.radio-item-img .playlist-add').data('song'),
                        poster: $(this).find('.radio-item-img .playlist-add').data('poster'),
                        artist: $(this).find('.radio-item-img .playlist-add').data('artist'),
                        free: true,
                        mp3: $(this).find('.radio-item-img .playlist-add').data('link'),
                        file: $(this).find('.radio-item-img .playlist-add').data('file')
                    });
                }
                checkedSongs++;
            }
        });
        if(checkedSongs === 0){
            alert('Please select at least one song.');
        } else{
            playlistPlayer.setPlaylist(playlistPlayer.playlist);
            $('.jp-playlist').slideDown(); 
        }
    });

    $(document).on("click", ".queue-list-btns .btn-clear", function (e) {
        e.preventDefault();
        var checkedSongs = 0;
        var allSongs = 0;
        var $this = $(this);
        $this.closest('.queue-list-header').next('.queue-list').find('.radio-item-list .radio-item').each(function(i, e){
            if($(this).find('input[type="checkbox"]').is(':checked')){
                var songID = $(this).find('.radio-item-img .playlist-add').data('song-id');
                playlistPlayer.playlist = playlistPlayer.playlist.filter(function(song) {  
                    return song.id !== songID;  
                });
                $this.closest('.queue-list-header').find('input[type="checkbox"]').prop('checked', false);
                $(this).find('input[type="checkbox"]').prop('checked', false);
                checkedSongs++;
            }
            allSongs++;
        });
        if(checkedSongs === 0){
            alert('Please select at least one song.');
        } else{
            if(checkedSongs === allSongs){
                playlistPlayer.remove();
                $('#media-player .radio-item .radio-item-img img').attr('src', 'assets/images/default.jpg');
                $('#media-player .radio-item .radio-item-img img').attr('alt', 'FM Derana Music');
                $('#media-player .radio-item .title').text('No media to play');
                $('#media-player .radio-item .artist').text('Select a song to play');
                $('.radio-item-list .radio-item').each(function(){
                    if($(this).hasClass('active')){
                        $(this).removeClass('active');
                    }
                });
            } else{
                playlistPlayer.setPlaylist(playlistPlayer.playlist);
                $('.jp-playlist').slideDown(); 
            }
        }
    });

    $('.jp-playlist').on('click', '.jp-playlist-item-remove', function(){
        // Determine song index if necessary
        var index = $(this).parents('li').index('.jp-playlist li');
        //console.log($('.jp-playlist li').length);

        // Retrieve song information, if necessary
        var song = playlistPlayer.playlist[index];
        //console.log(song); 
        $('.radio-item-list .radio-item').each(function(){
            if($(this).find('.radio-item-img a').data('song-id') === song.id){
                $(this).removeClass('active');
            }
        });

        if($('.jp-playlist li').length === 1){
            $('#media-player .radio-item .radio-item-img img').attr('src', 'assets/images/default.jpg');
            $('#media-player .radio-item .radio-item-img img').attr('alt', 'FM Derana Music');
            $('#media-player .radio-item .title').text('No media to play');
            $('#media-player .radio-item .artist').text('Select a song to play');
        }

    });

    $(document).on('click', '#playlist-close', function(){
		$('.jp-playlist').slideUp(); 
    });
    
    $(document).on('click', '#playlist-remove', function(){
        playlistPlayer.remove(); 
        $('#media-player .radio-item .radio-item-img img').attr('src', 'assets/images/default.jpg');
        $('#media-player .radio-item .radio-item-img img').attr('alt', 'FM Derana Music');
        $('#media-player .radio-item .title').text('No media to play');
        $('#media-player .radio-item .artist').text('Select a song to play');
        $('.radio-item-list .radio-item').each(function(){
            if($(this).hasClass('active')){
                $(this).removeClass('active');
            }
        });
    });

    $(document).on('click', '#playlist-save', function(){
        //console.log("Save Play list btn Clicked");
        var value = new Array();
        var len = playlistPlayer.playlist.length;
        //console.log(len);
        // var lastact = document.getElementById('paramLastactivity').value;
        // console.log(lastact);
        if (islogged == 0) {
            alert('Please login to save playlist.');
        } else {
            if (len == 0) {
                alert("Please add songs to your playlist");
            } else {

                for (var i = 0; i < len; i++) {
                    value[i] = playlistPlayer.playlist[i]['id'];
                }
                var path = window.location.href;

                var str = path.split("/");
                //console.log(str[4]);    
                var result;
                if (str[4] == 'profile'){
                    result = true;
                }else {
                    result = false;
                }

                //console.log(str[profile]);
                //console.log('save_playlist_pop.php?songId=' + value + '&cusid=' + loggedid);
                $.featherlight({
                    iframe: 'includes/player/save_playlist_pop.php?songId=' + value + '&cusid=' + loggedid + '&result=' + result,
                    loading: '<div class="spinner"><div class="cube1"></div><div class="cube2"></div></div>',
                    iframeMaxWidth: '100%',
                    iframeWidth: 500,
                    iframeHeight: 150
                });

            }
        }

    });


    //USER'S SAVED PLALIST PLAY
    $(document).on("click", ".users_saved_playlist_play", function () {
        
        playlistPlayer.remove();
        var upid = $(this).attr("up_id1");
        var poster_ = $(this).attr("poster");
        //alert(poster_);
        var this_ = $(this);
        $.ajax({
            type: 'GET',
            //url: 'index2.php?route=fan/loadtoplay&playlist_id=' + upid + '&uid=' + loggedid,
            url: 'includes/get-play-list.php',
            data: {playlist_id: upid, uid: loggedid},
            dataType: 'text',
            success: function (responce) {
                var data = JSON.parse(responce);
                for (var i =0; i < data.length; i++) {
                    if (data[i] != "") {
                        playlistPlayer.playlist.push({
                            id: data[i]['id'],
                            title: data[i]['name'],
                            artist: data[i]['artist'],
                            free: true,
                            poster: poster_,
                            mp3:'http://www.fmderana.lk/content/video/fmsongs/' + data[i]['file']
                        });
                    }
                }
                playlistPlayer.setPlaylist(playlistPlayer.playlist);
            }
        });
        
    });

//USER'S DELETE FAVOURITE
        $(document).on("click", ".remove-favourite", function (e) {
        e.preventDefault();
        var songId = $(this).attr("song-id");
        $.ajax({
                type: "POST",
                url: "includes/delete-fevorite.php",
                data: {songid: songId, uid: loggedid},
                dataType: 'json',
                
                success: function(data){
                    //console.log(data);
                    
                    var msg = JSON.parse(JSON.stringify(data));
                    // $("#error").html(msg.reason);
                    if(msg.success == true){
                        alert(msg.reason);
                        window.location.assign(msg.url);    
                    } else {
                        alert(msg.reason);
                    }
              },
              error: function(XMLHttpRequest, textStatus, errorThrown) { 
                    alert("Status: " + textStatus); 
                    alert("Error: " + errorThrown);
                    alert(XMLHttpRequest.responseText)
              }
            });
    });
 

    //USER'S DELETE PLALIST PLAY
    $(document).on("click", ".users_saved_playlist_delete", function () {
        var upid = $(this).attr("up_id1");
        var tag = 'delete';
        var poster_ = $(this).attr("poster");
        //alert(poster_);
        var this_ = $(this);
        //  loader('start', this_);
        if (confirm("Are you sure you want to permanently delete this playlist ?")) {

            $.ajax({
                type: 'GET',
                //url: 'index2.php?route=fan/loadtoplay&playlist_id=' + upid + '&uid=' + loggedid+'&tag='+tag,
                url: 'includes/delete-play-list.php',
                data: {playlist_id: upid, uid: loggedid, tag: tag},
                dataType: 'text',
                success: function (responce) {
                    alert(responce);
                    location.reload(true);
                }
            });

        } else {
            
        }
        
    });

}(jQuery));



